<template functional>
    <div>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16px"
            height="16px"
            viewBox="0 0 1024 1024"
        >
            <path
                fill="#D6001B"
                d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768a384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0a48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: "IconWarning",

    props: {
        size: { type: [String, Number], default: "16px" },
    },
};
</script>
